<template><div><h1>VUX V2.6.3 发布日志</h1>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[feature] 支持属性 radio-required 强制单选模式下必选一项 #2004</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] on-change 参数支持 labels #2018</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[fix] 修复组件函数名字以下划线开头将会被 Vue(2.4.4) 警告的问题 #2001</li>
<li>[feature] 添加 getCurrentIndex 方法</li>
<li>[feature] 添加 slot:button-before 和 slot:button-after</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 添加事件 on-blur</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] 修复 type 为 text 时使用 slot 缺失 padding 样式的问题</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] 点击错误图标时显示错误内容 #2009</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.3-254.vue?a5961114